import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import GlobalWrapper from '../../components/Wrapper/GlobalWrapper';
import GlobalTable from '../../components/CustomTableWithPagination/GlobalTable';
import { TableHead_Refund_fn } from '../../components/datagrid/refund/RefundRequestTableHead';
import dayjs from 'dayjs';
import { getDuplicateRefundRequestFinance } from '../../redux/features/refundSlice';
import { useLocation } from 'react-router-dom';

export default function DuplicateRequests() {
  const dispatch = useDispatch();
  const location = useLocation();

  const filters = location.state?.filters || {};

  const { data: tableRow, meta } = useSelector((state) => state.refund.duplicateRefundRequestFinance);

  const loading = useSelector(
    (state) => state.refund.duplicateRefundRequestFinance.duplicateRefundRequestFinanceLoading,
  );
  const [tableState, setTableState] = useState({
    page: 1,
    pageSize: 50,
    search: '',
    checkedRowIds: [],
    frozenColumns: [],
    hiddenColumns: [],
  });

  const [fromDate] = useState(filters?.fromDate || dayjs().startOf('month').format('YYYY-MM-DD'));

  const [toDate] = useState(filters?.toDate || dayjs().endOf('month').format('YYYY-MM-DD'));

  const dispatchParams = useMemo(() => {
    return {
      page: tableState.page,
      limit: tableState.pageSize,
      search: tableState.search || '',
      fromDate,
      toDate,
      statusBy: null,
      statusType: null,
    };
  }, [tableState.page, tableState.pageSize, tableState.search, fromDate, toDate]);
  useEffect(() => {
    dispatch(getDuplicateRefundRequestFinance(dispatchParams));
  }, [dispatch, dispatchParams]);

  // Find duplicates using enrollment id
  // const duplicateRows = useMemo(() => {
  //   const grouped = {};

  //   tableRow?.forEach((item) => {
  //     const key = item.expense_course_enrollment_id;

  //     if (!grouped[key]) {
  //       grouped[key] = [];
  //     }

  //     grouped[key].push(item);
  //   });

  //   return Object.values(grouped)
  //     .filter((group) => group.length > 1)
  //     .flat();
  // }, [tableRow]);

  const columns = useMemo(
    () =>
      TableHead_Refund_fn({
        selectedType: 0,
        approvalOrVerify: true,
        isFinance: true,
      }).filter(
        (col) => col.field !== 'sessions', // remove session column
      ),
    [],
  );
  return (
    <GlobalWrapper title="Duplicate Refund Requests">
      <Box sx={{ width: '100%' }}>
        <GlobalTable
          tableState={tableState}
          setTableState={setTableState}
          headers={columns}
          rows={tableRow}
          meta={meta}
          loading={loading}
          rowUniqueId="expense_id"
          exportUrl="refund-management/get-duplicate-request-for-finance"
          exportParams={{
            page: 1,
            limit: 50,
            search: tableState.search,
            fromDate,
            toDate,
            statusBy: null,
            statusType: null,
          }}
        />
      </Box>
    </GlobalWrapper>
  );
}
